import format from "date-fns/format";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../models/BasketItem";
import useFacility from "../../../../../utils/hooks/useFacility";

export default function useCustomHooks() {
  const { get, post } = useApiRequest();
  const facilityIds = useFacility();

  const addGuideToBasket = async (ids: number, qnt: number) => {
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const { isError } = await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
  };




  return {
    addGuideToBasket,
  };
}
